import React, { useEffect, useState } from 'react';
import { useViewlogies } from 'context';
import './header.scss';

const Header = () => {
    const {
        event: { organizationName, logoUrl },
    } = useViewlogies();

    const [imageClass, setImageClass] = useState('wide-logo');

    const getImageAspectRatio = async url => {
        const img = new Image();
        img.src = url;
        img.onload = () => {
            const aspectRatio = img.naturalWidth / img.naturalHeight;

            if (aspectRatio > 1.5) {
                setImageClass('wide-logo');
            } else {
                setImageClass('tall-logo');
            }
        };
    };

    useEffect(() => {
        if (logoUrl) {
            getImageAspectRatio(logoUrl);
        }
    }, [logoUrl]);

    return (
        <header className="client-header">
            <img src={logoUrl} alt={organizationName} className={imageClass} />
        </header>
    );
};

export default Header;
